export const FETCHING_VIDEOS = 'FETCHING_VIDEOS';
export const FETCHING_VIDEOS_SUCCESS = 'FETCHING_VIDEOS_SUCCESS';
export const FETCHING_VIDEOS_FAILED = 'FETCHING_VIDEOS_FAILED';

export const CREATING_VIDEOS = 'CREATING_VIDEO';
export const CREATING_VIDEO_FAILED = 'CREATING_VIDEO_FAILED';
export const CREATING_VIDEO_SUCCESS = 'CREATING_VIDEO_SUCCESS';


export const DELETING_VIDEOS = 'DELETING_VIDEOS';
export const DELETING_VIDEOS_COMPLETE = 'DELETING_VIDEOS_COMPLETE';
export const DELETING_VIDEOS_FAILED = 'DELETING_VIDEOS_FAILED';

export const GET_SINGLE_VIDEO = 'GET_SINGLE_VIDEO';
export const GET_SINGLE_VIDEO_COMPLETE = 'GET_SINGLE_VIDEO_COMPLETE';
export const GET_SINGLE_VIDEO_FAILED = 'GET_SINGLE_VIDEO_FAILED';
